import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "akdp-cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (print, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.print_id === print.id);
      if (found) return prev.map((i) => (i.print_id === print.id ? { ...i, qty: i.qty + qty } : i));
      return [
        ...prev,
        {
          print_id: print.id,
          title: print.title,
          price: print.price,
          image: print.images?.sm,
          edition_size: print.edition_size,
          qty,
        },
      ];
    });
  };

  const setQty = (print_id, qty) =>
    setItems((prev) => (qty <= 0 ? prev.filter((i) => i.print_id !== print_id) : prev.map((i) => (i.print_id === print_id ? { ...i, qty } : i))));

  const remove = (print_id) => setItems((prev) => prev.filter((i) => i.print_id !== print_id));
  const clear = () => setItems([]);

  const value = useMemo(
    () => ({
      items,
      add,
      setQty,
      remove,
      clear,
      count: items.reduce((s, i) => s + i.qty, 0),
      subtotal: items.reduce((s, i) => s + (i.price || 0) * i.qty, 0),
    }),
    [items]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
